import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "form-group text-cl" };
const _hoisted_2 = { class: "d-flex align-items-center" };
const _hoisted_3 = ["onUpdate:modelValue"];
const _hoisted_4 = ["onUpdate:modelValue"];
const _hoisted_5 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", null, _toDisplayString(_ctx.label), 1),
        _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-success ml-2",
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.add && _ctx.add(...args)))
        }, _cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "fas fa-plus" }, null, -1)
        ])),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "mb-1",
                key: i
            }, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, _toDisplayString(i + 1) + ".", 1),
                    _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                            class: "mr-1",
                            type: "text",
                            "onUpdate:modelValue": ($event) => ((_ctx.modelValue[i].name) = $event),
                            placeholder: "Nome"
                        }, null, 8, _hoisted_3), [
                            [_vModelText, _ctx.modelValue[i].name]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                            class: "mr-2",
                            type: "number",
                            "onUpdate:modelValue": ($event) => ((_ctx.modelValue[i].daysNeeded) = $event),
                            placeholder: "Giorni necessari"
                        }, null, 8, _hoisted_4), [
                            [_vModelText, _ctx.modelValue[i].daysNeeded]
                        ])
                    ]),
                    _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-danger ml-2",
                        onClick: ($event) => (_ctx.remove(i))
                    }, _cache[2] || (_cache[2] = [
                        _createElementVNode("i", { class: "fas fa-minus" }, null, -1)
                    ]), 8, _hoisted_5)
                ])
            ]));
        }), 128))
    ]));
}
